// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/chevron.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w7KETlmrCN8Ekc {
  position: relative;
  overflow: visible;
  line-height: 10px;
  vertical-align: top;
  white-space: nowrap;
}
.w7KETlmrCN8Ekc.sbC5V5FV8mXbmo {
  font-size: 8px;
}
.w7KETlmrCN8Ekc.PkNmqmQLu48HSf {
  padding: unset;
  border: 0;
  border-radius: var(--ds-border-radius-circle, 100%);
}
.fhvKsmPUNKspK2:hover {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  cursor: pointer;
}
.fhvKsmPUNKspK2.PXrUPxLInxAuOB {
  position: relative;
}
.fhvKsmPUNKspK2.PXrUPxLInxAuOB:hover::before {
  opacity: 0.2;
}
.fhvKsmPUNKspK2.PXrUPxLInxAuOB::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-circle, 50%);
  opacity: 0;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.nypJrJLOf1GNdv {
  position: absolute;
  z-index: 3;
  right: 1px;
  background-size: 100%;
}
.nypJrJLOf1GNdv {
  bottom: var(--ds-space-0, 0);
  width: 9px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.UUXk7U_m2LcHHZ {
  background-color: transparent;
}
`, ""]);
// Exports
export var memberAvatar = `w7KETlmrCN8Ekc`;
export var longInitials = `sbC5V5FV8mXbmo`;
export var clickableAvatar = `PkNmqmQLu48HSf`;
export var hoverable = `fhvKsmPUNKspK2`;
export var withImage = `PXrUPxLInxAuOB`;
export var admin = `nypJrJLOf1GNdv`;
export var transparentBackground = `UUXk7U_m2LcHHZ`;
export default ___CSS_LOADER_EXPORT___;
